// extracted by mini-css-extract-plugin
export var defaultWidth = "Slider-module--defaultWidth--77f9d";
export var mediumWidth = "Slider-module--mediumWidth--5ce0e";
export var smallWidth = "Slider-module--smallWidth--68159";
export var hidden = "Slider-module--hidden--179ab";